import ResidentsScreen from './ResidentsScreen'
import { useSelector } from 'react-redux'
import { Home } from '@lmc/ts-common'
import useHomeType from 'hooks/useHomeType'
import useFeatureFlags from 'hooks/useFeatureFlags'

export const ResidentScreenFeatureFlagWrapper = () => {
  const { hasRota } = useHomeType()

  const home = useSelector(
    (state: { global: { home: Home } }) => state?.global?.home
  )

  const flags = useFeatureFlags({
    flagNames: ['communication_records']
  })?.data

  const hasLegacyMedications = home?.features?.carePlanMeds?.enabled
  const communicationRecordsEnabled = flags?.communication_records?.enabled

  return (
    <ResidentsScreen
      hasLegacyMedications={hasLegacyMedications}
      hasRota={hasRota}
      communicationRecordsEnabled={communicationRecordsEnabled}
      data-testid="residents-screen-wrapper"
    />
  )
}
